import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export const IconContainerStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 7rem;
  background-color: ${colors.neutral[100]};
  border-radius: 5rem;
`;

export const MessageStyled = styled.p<{ $hasTitle: boolean }>`
  margin: 0;
  ${typography.regular[16]}
  color: ${({ $hasTitle }): string => ($hasTitle ? colors.neutral[600] : colors.neutral[900])};
`;

export const TitleStyled = styled.h3`
  ${typography.bold[18]}
  color: ${colors.neutral[700]};
  margin: 0;
`;

export const TextContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;
